import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { constants } from './Constant';

const Bootcamp = () => {
  return (
    <>
      <Header />
        <div id="myDIV" style={{ backgroundImage: `url(${require('../assets/images/meetings-bg.jpg')})` }}>
          <div>
            <div class="row">
              <div class="col-lg-12">
                <div class="caption caption-content">
                  <h2 style={{padding:"20px",color:"white"}}>{constants?.bootCampPage?.title1}</h2>
                    {/* <ul class="sub-content">
                      <li><span>&#9755;</span>{constants?.bootCampPage?.description1}</li>
                      <li><span>&#9755;</span>{constants?.bootCampPage?.description2}</li>
                      <li><span>&#9755;</span>{constants?.bootCampPage?.description3}</li>
                      <li><span>&#9755;</span>{constants?.bootCampPage?.description4}</li>
                      <li><span>&#9755;</span>{constants?.bootCampPage?.description5}</li>
                    </ul> */}

<div className="col-lg-12">
            <div className="row">
              <Bootcampitem 
                // price="$22.00"
                // date={{ day: "10", month: "Nov" }}
                // imgSrc={meeting01}
                title={constants?.bootCampPage?.description1}
                // link="meeting-details.html"
                // description={     <ul class="sub-content">
                //   <li><span>&#9755;</span>{constants?.bootCampPage?.description1}</li>
                //   <li><span>&#9755;</span>{constants?.bootCampPage?.description2}</li>
                //   <li><span>&#9755;</span>{constants?.bootCampPage?.description3}</li>
                //   <li><span>&#9755;</span>{constants?.bootCampPage?.description4}</li>
                //   <li><span>&#9755;</span>{constants?.bootCampPage?.description5}</li>
                // </ul>}
              />
              <Bootcampitem
                // price="$36.00"
                // date={{ day: "24", month: "Nov" }}
                // imgSrc={meeting02}
                title={constants?.bootCampPage?.description2}
                // link="meeting-details.html"
                // description={}
              />
              <Bootcampitem
                // price="$14.00"
                // date={{ day: "26", month: "Nov" }}
                // imgSrc={meeting03}
                title={constants?.bootCampPage?.description3}
                // link="meeting-details.html"
                // description={}
               
              />

<Bootcampitem
                // price="$14.00"
                // date={{ day: "26", month: "Nov" }}
                // imgSrc={meeting03}
                title={constants?.bootCampPage?.description4}
                // link="meeting-details.html"
                // description={}
               
              />


<Bootcampitem
                // price="$14.00"
                // date={{ day: "26", month: "Nov" }}
                // imgSrc={meeting03}
                title={constants?.bootCampPage?.description5}
                // link="meeting-details.html"
                // description={}
               
              />



               
            </div>
          </div>

              </div>
              </div>
            </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

const Bootcampitem = ({ price, date, imgSrc, title, link, description }) => {
  return (
    <div className="col-lg-4" >
      <div className="meeting-item">
        <div className="sports-item" style={{backgroundColor:"white"}} >
        
          <a href={link}><h4>{title}</h4></a>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Bootcamp;
